import {SKYWAY_API_HOST} from './const';

import type {SkywayAjaxOption} from '../types/internal';

/**
 * @param method
 * @param url
 * @param option
 */
export const apiAjax = (method: string, url: string, option: SkywayAjaxOption) => {
  const api_url = SKYWAY_API_HOST + url;
  // 明示的にnullを送るケースあり
  const payload = option.data === undefined ? null : option.data;
  const ajax = new XMLHttpRequest();
  ajax.open(method, api_url);
  ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  ajax.send(JSON.stringify(payload));
  ajax.addEventListener(
    'load',
    function (e: ProgressEvent) {
      try {
        if (e.target === null || e.target === undefined || !('response' in e.target)) {
          return;
        }
        const response: object = JSON.parse(e.target['response'] as string);
        if ((e.target as any)['status'] === 200) {
          if (option.done !== undefined && option.done !== null) {
            option.done(response);
          }
        } else {
          if (option.error !== undefined && option.error !== null) {
            option.error(response);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    false
  );
};
